import React from "react";
import Modal from "react-responsive-modal";
import { SpinnerCircularFixed } from "spinners-react";

export interface WarningModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  messageTitle?: string;
  message?: React.ReactNode;
  /** Optional content rendered between the message and the action buttons. Use for forms or extra fields. */
  additionalContent?: React.ReactNode;
  confirmLabel: string;
  onConfirm: () => Promise<void> | void;
  isLoading?: boolean;
  disabled?: boolean;
  confirmButtonClassName?: string;
  ConfirmIcon?: React.ElementType;
  discardLabel?: string;
}

export const WarningModal: React.FC<WarningModalProps> = ({
  open,
  onClose,
  title,
  messageTitle,
  message,
  additionalContent,
  confirmLabel,
  onConfirm,
  isLoading = false,
  disabled = false,
  confirmButtonClassName = "bg-blue-600 hover:bg-blue-700",
  ConfirmIcon,
  discardLabel = "Descartar",
}) => {
  return (
    <Modal
      classNames={{
        modal: `bg-white w-auto sm:w-[550px] rounded-2xl shadow-modal !p-0`,
        overlay: `bg-modal-overlay`,
      }}
      showCloseIcon={false}
      open={open}
      onClose={onClose}
      center
      focusTrapped={false}
    >
      <div className="p-8 sm:p-8 sm:pb-6">
        <h1 className="border-b border-gray-200 pb-4 text-xl font-bold text-gray-900">
          {title}
        </h1>
        {(messageTitle || message) && (
          <div className="mb-10 mt-6 flex flex-col gap-2">
            {messageTitle && (
              <h2 className="font-semibold text-gray-900">{messageTitle}</h2>
            )}
            {message && <div className="text-gray-600">{message}</div>}
          </div>
        )}
        {additionalContent != null && (
          <div className="mb-6 flex flex-col gap-4">{additionalContent}</div>
        )}
        <div className="flex flex-col justify-end gap-3 sm:flex-row">
          <button
            className="h-12 rounded-lg border border-gray-200 bg-white px-6 py-2 text-sm text-gray-900 transition-colors duration-300 hover:bg-gray-100"
            onClick={onClose}
          >
            {discardLabel}
          </button>
          <button
            className={`flex h-12 items-center justify-center gap-2 rounded-lg px-6 py-2 text-sm text-white transition-colors duration-300 disabled:cursor-not-allowed disabled:opacity-50 ${confirmButtonClassName}`}
            disabled={isLoading || disabled}
            onClick={onConfirm}
          >
            {isLoading ? (
              <SpinnerCircularFixed size={16} color="#FFFFFF" secondaryColor="#000000" />
            ) : ConfirmIcon ? (
              <ConfirmIcon className="h-4 w-4 shrink-0" />
            ) : null}
            {confirmLabel}
          </button>
        </div>
      </div>
    </Modal>
  );
};


